import React from "react";

export default function TabPanel({ id, activeTab, children }) {
  return activeTab === id ? <li>{children}</li> : null;
}
